// Privacy-first product analytics wrapper around PostHog.
// - No autocapture, no session recording (configured in index.html).
// - Anonymous before account creation; identify only after auth.
// - Never pass passwords, business content, AI prompts, or generated assets.
// - Consent-gated: capturing stays paused until the user accepts.

const CONSENT_KEY = "lti_analytics_consent"; // "granted" | "denied"

function ph() {
  return typeof window !== "undefined" ? window.posthog : undefined;
}

export function getConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

export function grantConsent() {
  try {
    localStorage.setItem(CONSENT_KEY, "granted");
  } catch {
    /* ignore */
  }
  const p = ph();
  if (p && p.opt_in_capturing) p.opt_in_capturing();
}

export function denyConsent() {
  try {
    localStorage.setItem(CONSENT_KEY, "denied");
  } catch {
    /* ignore */
  }
  const p = ph();
  if (p && p.opt_out_capturing) p.opt_out_capturing();
}

// Apply the stored choice on load. Until a choice is made, keep capturing paused.
export function applyStoredConsent() {
  const p = ph();
  if (!p) return;
  const c = getConsent();
  if (c === "granted" && p.opt_in_capturing) p.opt_in_capturing();
  else if (p.opt_out_capturing) p.opt_out_capturing();
}

// Track a whitelisted product event. Only pass non-sensitive properties.
export function track(event, properties = {}) {
  if (getConsent() !== "granted") return;
  const p = ph();
  if (p && p.capture) p.capture(event, properties);
}

// Identify the user only after authentication. Email is used as the distinct id;
// never send business content here.
export function identifyUser(user) {
  if (getConsent() !== "granted" || !user) return;
  const p = ph();
  if (p && p.identify) {
    p.identify(user.user_id, { role: user.role });
  }
}

export function resetAnalytics() {
  const p = ph();
  if (p && p.reset) p.reset();
}
